// 9fbef606107a605d69c0edbcd8029e5d
import { takeLeading, call, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getDyRecommendations,
  sendDyTrackEvent,
} from '@tcp/core/src/services/abstractors/common/recommendations/dyRecommendations';
import { dyPageNames } from '@tcp/core/src/services/abstractors/common/recommendations/utils/constants';
import {
  getUserLoggedInState,
  isPlccUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  FETCH_DY_RECOMMENDATIONS_DATA,
  SEND_TRACK_EVENTS_TO_DY,
} from './DyRecommendations.constants';
import { setLoadingState, setDyRecommendationsData } from './DyRecommendations.actions';

export function* loadDyRecommendations(action) {
  const { payload = {} } = action;
  const { pageName, primaryCategory, outOfStock } = payload;
  const isLoggedIn = yield select(getUserLoggedInState);
  const isPLCCUser = yield select(isPlccUser);

  let pageAttributes = { isRegistered: isLoggedIn || false, hasPlcc: isPLCCUser || false };

  const isPDP = pageName === dyPageNames.PDP;
  if (isPDP) {
    pageAttributes = {
      ...pageAttributes,
      primaryCategory: primaryCategory || '',
      outOfStock: outOfStock || false,
    };
  }

  payload.pageAttributes = pageAttributes;

  try {
    yield put(setLoadingState({ pageName, value: true }));
    const response = yield call(getDyRecommendations, payload);
    yield put(setDyRecommendationsData({ data: response, pageName }));
    yield put(setLoadingState({ pageName, value: false }));
  } catch (e) {
    yield put(setLoadingState({ pageName, value: false }));
    logger.error('Error occurred in DyRecommendationsSaga at loadDyRecommendations method -', {
      error: e,
      extraData: {
        payloadRecieved: payload,
      },
    });
  }
}

export function* sendDyTrackEventSaga(action) {
  const {
    payload: { recSlotId, decsId },
  } = action;
  try {
    if (recSlotId) {
      yield call(sendDyTrackEvent, { recSlotId, decsId });
    }
  } catch (e) {
    logger.error('Error has occurred: ', {
      error: e,
      extraData: {
        component: 'Dy Recommendations Saga - sendTrackEventsToDy',
        recSlotId,
      },
    });
  }
}

function* RecommendationsSaga() {
  yield takeLeading(FETCH_DY_RECOMMENDATIONS_DATA, loadDyRecommendations);
  yield takeLeading(SEND_TRACK_EVENTS_TO_DY, sendDyTrackEventSaga);
}

export default RecommendationsSaga;
